import React from "react";
import { useGetBiUserActivityQuery } from "../../app/api/console/consoleBiApiSlice";
import UserActivityTable from "./UserActivityTable";

/**
 * The BI sessions table scoped to one brand (Customer Analytics expanded row):
 * one row per Hub session with the expandable event timeline and Hub links.
 */
export default function CustomerSessions({ brandName, enabled, startDate, endDate, limit = 300 }) {
  const { data, isLoading, error } = useGetBiUserActivityQuery(
    { startDate, endDate, brands: brandName ? [brandName] : [], limit, offset: 0, useProd: true },
    { skip: !enabled || !brandName }
  );
  return <UserActivityTable data={data} isLoading={isLoading} error={error} useProd />;
}
